import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Why companies choose to build on Segment`,
}

const data: FeatureProps[] = [
  {
    title: `2x`,
    subtitle: `Conversion rates`,
    bodyTitle: `Reduce time to value`,
    body: `Get data flowing in 30 seconds with access to all historical customer data. Partners report 2x their average conversion rate.`,
  },

  {
    title: `9,000`,
    subtitle: `Integrations enabled / month`,
    bodyTitle: `Get discovered`,
    body: `Get noticed by tens of thousands of Segment customers and become one of the 9,000 integrations they enable each month.`,
  },

  {
    title: `${process.env.INTEGRATION_COUNT}+`,
    subtitle: `Integrations`,
    bodyTitle: `Unlock more data`,
    body: `Integrating with Segment means you’re connected to ${process.env.INTEGRATION_COUNT}+ data sources and destinations. All powered by one simple integration.`,
  },
]

const Features = () => {
  return (
    <SectionBase variant="centered">
      <WiderSectionCopy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
        </CopyTextBase>
      </WiderSectionCopy>
      <Section.Contents>
        <SpacedColumnTrack columns={1} overrides={{ md: 3 }} center={true}>
          {data.map((feature, i) => (
            <Feature key={i} {...feature} />
          ))}
        </SpacedColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

export default Features

const WiderSectionCopy = styled(Section.Copy)`
  max-width: 844px;
`

const SpacedColumnTrack = styled(ColumnTrack)`
  column-gap: 64px;
`

interface FeatureProps {
  title: string
  subtitle: string
  bodyTitle: string
  body: string
}
const Feature: FC<PropsWithChildren<FeatureProps>> = ({ title, subtitle, bodyTitle, body }) => {
  return (
    <StyledFeatureBoxBase headerPosition="top">
      <FeatureBox.Header>
        <FeatureBox.Title variant="h2">{title}</FeatureBox.Title>
        <FeatureBoxSubtitle variant="h6">{subtitle}</FeatureBoxSubtitle>
      </FeatureBox.Header>
      <FeatureBox.Body>
        <FeatureBox.Title>{bodyTitle}</FeatureBox.Title>
        <FeatureBox.Text>{body}</FeatureBox.Text>
      </FeatureBox.Body>
    </StyledFeatureBoxBase>
  )
}

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  max-width: 352px;
`

const FeatureBoxSubtitle = styled(FeatureBox.Title)`
  color: ${({ theme }) => theme.palette.twilio.gray[80]};
`
